module.exports = __webpack_public_path__ + "img/trattoria.af707ad0.jpg";